import { ViewModel,View, ObservableArray, DelegatedObservableArrayChangeListenner, Component } from "binder"
import { ListSyncronizer } from "./../../componentUtilities";
import  { MultiSelectComboBoxView } from "./multiSelectComboBox-view"

export class MultiSelectComboBoxViewModel extends Component{
    
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.selectedItemsWithContainer = ObservableArray.create<headerContainer>();
        this.itemsWithContainer = ObservableArray.create<itemContainer>();
        this.listItems = ObservableArray.create<ViewModel>();
        this.selecteditems = ObservableArray.create<ViewModel>();
        this.items = ObservableArray.create<ViewModel>();
        this.isShowingPopup = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new MultiSelectComboBoxView();
    }
    public getTypeId(): string {
        return "VM-122BFE30-3A26-4EC3-9A2F-D8C3695071D7"
    }

    private _sourceItemsChangeListenner : DelegatedObservableArrayChangeListenner;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;

    public set items(v: ObservableArray<ViewModel>) { 
        if(this.items){
            this.items.removeChangeListenner(this._sourceItemsChangeListenner);
        }    
        this._items = v; 
        if(this.items){
            this._sourceItemsChangeListenner = new DelegatedObservableArrayChangeListenner(this,()=>this.sourceItemsChanged())
            this.items.addChangeListenner(this._sourceItemsChangeListenner);
            this.sourceItemsChanged();
        }
    } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    
    public set listItems(v: ObservableArray<ViewModel>) { 
        if(this.listItems){
            this._itemsSynronizer.release();
        }  
        this._listItems = v; 
        if(this.listItems){
            this.createItemsSynronizer();

        }
    } public get listItems(): ObservableArray<ViewModel> { return this._listItems;} private _listItems: ObservableArray<ViewModel>;
    public set selecteditems(v: ObservableArray<ViewModel>) { 
        if(this.selecteditems){
            this._selectedItemsSyncronizer.release();
        }
        this._selecteditems = v; 
        if(this.selecteditems){
            this.createSelectedItemsSynronizer();
        }
    } public get selecteditems(): ObservableArray<ViewModel> { return this._selecteditems;} private _selecteditems: ObservableArray<ViewModel>;
    
    public set itemsWithContainer(v: ObservableArray<itemContainer>) { this._itemsWithContainer = v; } public get itemsWithContainer(): ObservableArray<itemContainer> { return this._itemsWithContainer;} private _itemsWithContainer: ObservableArray<itemContainer>;
    public set selectedItemsWithContainer(v: ObservableArray<headerContainer>) { this._selectedItemsWithContainer = v; } public get selectedItemsWithContainer(): ObservableArray<headerContainer> { return this._selectedItemsWithContainer;} private _selectedItemsWithContainer: ObservableArray<headerContainer>;

    private _itemsSynronizer:ListSyncronizer<ViewModel,itemContainer>;
    private _selectedItemsSyncronizer:ListSyncronizer<ViewModel,headerContainer>;

    createSelectedItemsSynronizer() {
        this._selectedItemsSyncronizer = new ListSyncronizer<ViewModel,headerContainer>();
        this._selectedItemsSyncronizer.synronize(this.selecteditems,this.selectedItemsWithContainer,x=>{
            let r = new headerContainer(this);
            r.content = x;
            return r;
        })
    }
    createItemsSynronizer() {
        this._itemsSynronizer = new ListSyncronizer<ViewModel,itemContainer>();
        this._itemsSynronizer.synronize(this.listItems,this.itemsWithContainer,x=>{
            let r = new itemContainer(this);
            r.content = x;
            return r;
        })
    }
    sourceItemsChanged(): void {
        let removedSelectedItems = this.selecteditems.filter(x=>this.items.indexOf(x)==-1);
        let remaingSelectedItems = this.selecteditems.filter(x=>removedSelectedItems.indexOf(x)==-1);
        let newItemsList = this.items.filter(x=>remaingSelectedItems.indexOf(x)==-1);
        this.listItems.update(...newItemsList);
        this.selecteditems.update(...remaingSelectedItems);
    }
    select(item: itemContainer) {
        this.selecteditems.push(item.content);
        this.listItems.remove(item.content);
    }
    removeSelected(headerItem: headerContainer) {
        let item = headerItem.content;
        this.selecteditems.remove(item);
        let inserted = false;
        for(let i=0,j=0;i<this.items.length && j<this.listItems.length;){
            let itemsElement = this.items[i];
            let listElement = this.listItems[j];
            if(itemsElement==listElement){
                i++;
                j++;
            }else{
                if(itemsElement==item){
                    this.listItems.splice(j,0,item);
                    inserted = true;
                    break;
                }else{
                    i++;
                }
            }
        }
        if(inserted==false){
            this.listItems.push(item);
        }
    }
    
}


export class itemContainer extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:MultiSelectComboBoxViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent:MultiSelectComboBoxViewModel;
    public set content(v: ViewModel) { this._content = v; } public get content(): ViewModel { return this._content;} private _content: ViewModel;

    select(){
        this._typedParent.select(this);
    }
}

export class headerContainer extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:MultiSelectComboBoxViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent:MultiSelectComboBoxViewModel;
    public set content(v: ViewModel) { this._content = v; } public get content(): ViewModel { return this._content;} private _content: ViewModel;
    
    remove(){
        this._typedParent.removeSelected(this);        
    }
}
